export default __webpack_public_path__ + "static/media/assetSample2@3x.4f22ce41.png";